"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Star16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "star-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M5.43968678,11.8327422 L8,10.7354397 L10.5603132,11.8327422 L10.3078969,9.0586545 L12.1426738,6.96273703 L9.42635871,6.34555901 L8,3.95290832 L6.57364129,6.34555901 L3.85732618,6.96273703 L5.69210313,9.0586545 L5.43968678,11.8327422 Z M3.14390536,14.9926142 L3.62265838,9.73105785 L0.142673817,5.75577331 L5.2946541,4.58518416 L8,0.0470916804 L10.7053459,4.58518416 L15.8573262,5.75577331 L12.3773416,9.73105785 L12.8560946,14.9926142 L8,12.9113827 L3.14390536,14.9926142 Z", id: "Star", fill: "#000000", fillRule: "nonzero" })));
}
function Star16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Star16Svg, Object.assign({}, svgProps)));
}
exports.default = Star16;
//# sourceMappingURL=Star16.js.map